'use client'

import React, { useState } from 'react'

import { useQuery } from '@apollo/client'

import { JoinUsNowModal } from 'Components/Blocks/Modals'
import {
  BusinessIndividualSection,
  ExploreCorporateMembershipSection,
  FAQSection,
  MembershipsIndividualHeroSection,
  TestimonialsSection,
  WhyChooseEmajinGolfSection,
} from 'Components/Sections'
import { Column, Loader } from 'Components/UI'
import { APOLLO_CLIENT_CONTEXT_ID } from 'Config/apolloClient'

import { MembershipsIndividualPageDocument } from 'GraphQL/DatoCMS/TypedDocuments'

function MembershipsIndividualPage() {
  const [joinUsModalModalOpened, setJoinUsModalModalOpened] = useState(false)

  const { data, loading } = useQuery(MembershipsIndividualPageDocument, {
    context: { [APOLLO_CLIENT_CONTEXT_ID.Dato]: true },
  })

  if (loading) return <Loader fullScreen size={32} />

  return (
    <Column alignCenter fullWidth>
      <MembershipsIndividualHeroSection
        onAction={() => setJoinUsModalModalOpened(true)}
      />

      <BusinessIndividualSection
        membershipPackage={data?.membershipsIndividualPage?.membershipPackage}
        pt={[50, 50, 50, 100]}
        onAction={() => setJoinUsModalModalOpened(true)}
      />

      <WhyChooseEmajinGolfSection
        secondary
        onAction={() => setJoinUsModalModalOpened(true)}
      />

      <ExploreCorporateMembershipSection />

      <TestimonialsSection
        data={data?.membershipsIndividualPage?.testimonials}
        onAction={() => setJoinUsModalModalOpened(true)}
      />

      <FAQSection data={data?.membershipsIndividualPage?.faq} />

      <JoinUsNowModal
        isOpened={joinUsModalModalOpened}
        onClose={() => setJoinUsModalModalOpened(false)}
      />
    </Column>
  )
}

export default MembershipsIndividualPage
